<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:44
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-18 16:46:49
-->
<template>
  <div class="model" :style="{ backgroundColor: `${bColor}80` }">
    <div class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">
      {{ title }}
    </div>
    <slot name="progress"></slot>
    <div :class="['modelBg', `modelBg0`]">
      <div class="list first" v-if="firstItems(list)">
        <div class="item" v-for="(item, index) in firstItems(list)" :key="index">
          <div class="itemImg" :style="{ borderColor: bColor }">
            <img :src="item.img" />
          </div>
          <div class="name" :style="{ backgroundColor: bColor, color: textColor }">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="list two" v-if="twoItems(list)">
        <div class="item" v-for="(item, index) in twoItems(list)" :key="index">
          <div class="itemImg" :style="{ borderColor: bColor }">
            <img :src="item.img" />
          </div>
          <div class="name" :style="{ backgroundColor: bColor, color: textColor }">
            <div :class="item.name .length>11?'name_animate':''" >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="list" v-if="items(list).length > 0">
        <div class="item" v-for="(item, index) in items(list)" :key="index">
          <div class="itemImg" :style="{ borderColor: bColor }">
            <img :src="item.img" />
          </div>
          <div class="name" :style="{ backgroundColor: bColor, color: textColor }">
              <div :class="item.name .length>9?'name_animate':''" >
                {{ item.name }}
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "bColor", "title", "textColor"],
  data() {
    return { list: [] };
  },
  created() {},
  methods: {
    firstItems(item) {
      if (item.length % 3 == 1) {
        return [item[0]];
      }
    },
    twoItems(item) {
      if (item.length % 3 == 2) {
        return [item[0], item[1]];
      }
    },
    items(item) {
      return item.slice(item.length % 3);
    },
  },
  computed: {
    modelBg() {
      return {
        background: this.btnBgColor,
        boxShadow: `0px 2px 3px ${this.btnBgColor}5c`,
      };
    },
  },
  filters: {},
  watch: {
    data: {
      handler(val) {
        this.list = val;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.model {
  width: 351px;
  margin: 24px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  padding: 10px;

  .modelTitle {
    position: absolute;
    margin-top: -10px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    border-radius: 0px 0px 12px 12px;
    z-index: 1;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;
    padding: 54px 10px 0;
    margin-bottom: 14px;
    .listTitle {
      font-weight: 600;
      font-size: 18px;
      color: #4870ff;
      text-align: center;
      margin-bottom: 16px;
    }

    .list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &.first {
        .item {
          width: 299px;
          .itemImg {
            width: 299px;
            height: 130px;
            img {
              width: 297px;
              height: 127px;
            }
          }
          .name {
            width: 100%;
          }
        }
      }

      &.two {
        .item {
          width: 144px;
          .itemImg {
            width: 144px;
            height: 100px;
            img {
              width: 142px;
              height: 97px;
            }
          }
          .name {
            width: 100%;
          }
        }
      }

      .item {
        border-radius: 4px;
        overflow: hidden;
        margin: 0 5px 12px;
        width: 93px;

        .itemImg {
          border-radius: 4px 4px 0 0;
          width: 93px;
          height: 93px;
          background-color: #f0f0f0;
          border-style: solid;
          border-width: 1px;

          img {
            border-radius: 2px 2px 0 0;
            width: 91px;
            height: 90px;
            object-fit: contain;
          }
        }

        .name {
          border-radius: 0 0 4px 4px;
          width: 100%;
          font-weight: normal;
          font-size: 11px;
          line-height: 20px;
          color: white;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 2px;
        }
      }
    }
  }
  .modelBg:last-child {
    margin-bottom: 0;
  }
}
.name_animate{
  animation: marquee_animate 10s infinite linear;
}
    
@keyframes marquee_animate {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
